/**
 * ErrorBanner — inline error message below the status badge.
 * Message text is app-authored (we map raw SDK errors to copy before
 * calling this), so textContent is a safety default, not a workaround.
 */
export function ErrorBanner({ message }) {
  const el = document.createElement("div");
  el.className = "error-banner";
  el.textContent = message;
  return el;
}
